import i18next from 'i18next';

i18next.addResources('es_CL', 'CallCenterLogin', {
  pageTitle: "Papa John's | Call Center",
  pageDescription: 'Dashboard para realización de pedidos a traves de llamadas.'
});
